'use client';

import { c as _c } from "react/compiler-runtime";
import { unwrapFromResult } from '@shared/utils/helpers/resultWrapper';
import useDatabase from '@shared/utils/hooks/useDatabase';
import { useQuery } from '@tanstack/react-query';
import useContentUIRenderer from '../../hooks/useContentUIRenderer';
import { client } from '../../utils/trpc';
import Avatar from '../common/Avatar';
import Error from '../common/Error';
import Modal, { ModalContent, ModalHeader } from '../HOC/Modal';
type Props = {
  closeHandler: () => void;
  postId: string;
  avatarKey: string | null;
  robohash: string | null;
  isBot: boolean;
  userId: number;
  isPrivate?: boolean;
};
const ViewPostHistory = t0 => {
  const $ = _c(33);
  const {
    closeHandler,
    postId,
    avatarKey,
    robohash: t1,
    isBot,
    userId,
    isPrivate
  } = t0;
  const robohash = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== avatarKey || $[1] !== isBot || $[2] !== robohash || $[3] !== userId) {
    t2 = {
      avatarKey,
      robohash,
      isBot,
      userId
    };
    $[0] = avatarKey;
    $[1] = isBot;
    $[2] = robohash;
    $[3] = userId;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const fallbackEditor = t2;
  const {
    getPrivatePostEditHistory
  } = useDatabase();
  const {
    contentUIRenderHandler
  } = useContentUIRenderer();
  let t3;
  if ($[5] !== isPrivate || $[6] !== postId) {
    t3 = ["postEditHistory", postId, isPrivate];
    $[5] = isPrivate;
    $[6] = postId;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== getPrivatePostEditHistory || $[9] !== isPrivate || $[10] !== postId) {
    t4 = async () => {
      if (isPrivate) {
        return getPrivatePostEditHistory(postId);
      }
      return unwrapFromResult(client.posts.editHistory.query({
        postId
      }));
    };
    $[8] = getPrivatePostEditHistory;
    $[9] = isPrivate;
    $[10] = postId;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t3 || $[13] !== t4) {
    t5 = {
      queryKey: t3,
      queryFn: t4
    };
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  const {
    isLoading,
    isError,
    data
  } = useQuery(t5);
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h2>Post History</h2>;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== closeHandler) {
    t7 = <ModalHeader closeHandler={closeHandler}>{t6}</ModalHeader>;
    $[16] = closeHandler;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== contentUIRenderHandler || $[19] !== data || $[20] !== fallbackEditor || $[21] !== isError || $[22] !== isLoading || $[23] !== postId) {
    t8 = !isLoading && !isError && data && data.edits.length !== 0 && <ModalContent><div className="flex flex-col gap-3 rounded-lg bg-background-primary text-white">{data.edits.map((item, i) => {
          const editor = "editor" in item ? item.editor : fallbackEditor;
          return <div key={item.id} className="flex items-start space-x-2 rounded-lg bg-background-secondary p-2 text-start"><section className="flex flex-col items-center"><Avatar avatarKey={editor.avatarKey} robohash={editor.robohash} isBot={editor.isBot} size={35} userId={editor.userId} /><div className="h-full w-px bg-ds-border-standard" /></section><div className="flex flex-col gap-y-1"><span className="font-semibold text-textSecondary/80">{data.edits.length - i === 1 ? "Original Post" : `Edited on ${new Date(item.date).toLocaleDateString()} ${new Date(item.date).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit"
                })}`}</span><div className="text-textPrimary">{contentUIRenderHandler(item.content, postId, true, {
                  hideLinkPreview: true
                })}</div></div></div>;
        })}</div></ModalContent>;
    $[18] = contentUIRenderHandler;
    $[19] = data;
    $[20] = fallbackEditor;
    $[21] = isError;
    $[22] = isLoading;
    $[23] = postId;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  const t9 = isError || data?.edits?.length === 0;
  let t10;
  if ($[25] !== isLoading || $[26] !== t9) {
    t10 = <Error loading={isLoading} error={t9} />;
    $[25] = isLoading;
    $[26] = t9;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== closeHandler || $[29] !== t10 || $[30] !== t7 || $[31] !== t8) {
    t11 = <Modal closeHandler={closeHandler}>{t7}{t8}{t10}</Modal>;
    $[28] = closeHandler;
    $[29] = t10;
    $[30] = t7;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  return t11;
};
export default ViewPostHistory;